import React, { useRef, useState } from "react";
import { FaTimes, FaPrint } from "react-icons/fa";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ResumeTemplate from "./ResumeTemplate";
import "./ResumeModal.css";

const ResumeModal = ({ user, industryLabel, scopeName, onClose }) => {
  const printRef = useRef(null);
  const [generating, setGenerating] = useState(false);

  const handleDownloadPdf = async () => {
    if (!printRef.current) return;
    setGenerating(true);

    try {
      const canvas = await html2canvas(printRef.current, {
        scale: 2, // sharper output
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      // A4 page in points: 595.28 x 841.89
      const pdf = new jsPDF("p", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // If content is taller than one page, add more pages
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const fileName = `${(user?.full_name || "resume").replace(/\s+/g, "_")}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="resume-modal-overlay">
      <div className="resume-modal-toolbar resume-no-print">
        <span className="resume-modal-title">Resume Preview</span>
        <div className="resume-modal-actions">
          <button
            className="resume-btn resume-btn-primary"
            onClick={handleDownloadPdf}
            disabled={generating}
          >
            <FaPrint /> {generating ? "Downloading..." : "Download PDF"}
          </button>
          <button className="resume-btn resume-btn-ghost" onClick={onClose}>
            <FaTimes /> Close
          </button>
        </div>
      </div>

      <div className="resume-modal-body">
        <ResumeTemplate
          ref={printRef}
          user={user}
          industryLabel={industryLabel}
          scopeName={scopeName}
        />
      </div>
    </div>
  );
};

export default ResumeModal;